import { InflatedListItemProduct } from '../list/ListTypes'
import { BuildConfig } from '../config/BuildConfig'
import { getColorDisplayName } from '../products/productUtils'
import { getListInterfaceDisplayName } from '../list/listItemUtils'
import { ClipspecIconicProductData } from './clipspec-api/ClipspecIntegrationAPI'
import { generateFullBom, getBomProductsForInflatedItem } from '../bom/bomUtils'
import { noOpPackQuantityProvider } from '../bom/NoOpPackQuantityProvider'
import { getRangeDisplayName } from '../products/productDisplayUtils'

type ClipspecIconicProductDataWithoutImage = Omit<ClipspecIconicProductData, 'image'>

function getClipspecProductDescription(product: InflatedListItemProduct) {
  const baseDescription = [
    BuildConfig.brand.brandName,
    getRangeDisplayName(product.skinProduct.style),
    getColorDisplayName(product.skinProduct.color),
    getBaseProductDescription(product),
  ]
    .filter(it => it != null)
    .map(it => it.trim())
    .filter(it => it.length > 0)
    .join(' ')

  const interfaces = product.configuredButtons.map(item => {
    return getListInterfaceDisplayName(item.interfaceProduct, item.mechProduct)
  }).join(', ')

  if (interfaces.length > 0) {
    return `${baseDescription}, with ${interfaces}`
  }

  return baseDescription
}

function getBaseProductDescription(product: InflatedListItemProduct): string {
  switch (product.skinProduct.type) {
    case 'Switch':
      if (product.skinProduct.gridProduct?.gangNo) {
        return `${product.skinProduct.gridProduct.gangNo} gang Switch`
      } else {
        return 'Switch'
      }

    case 'Socket':
      return product.skinProduct.displayName

    case 'Other':
      return product.skinProduct.displayName
  }
}

export function getClipspecConfiguredProductPayload(configuredProduct: InflatedListItemProduct): ClipspecIconicProductDataWithoutImage {
  // Always generate the bom for a single item, then pass through the overall quantity
  const singleQuantityBom = getBomProductsForInflatedItem({ ...configuredProduct, quantity: 1 })

  return {
    description: getClipspecProductDescription(configuredProduct),
    quantity: configuredProduct.quantity,
    components: generateFullBom([singleQuantityBom], noOpPackQuantityProvider)
      .map(it => ({
        itemNo: it.itemNo,
        quantity: it.individualQuantity,
      })),
  }
}
